// The browser clipboard (impure: navigator I/O).

import type { ClipboardPorts, CopyOutcome } from "../ports/clipboard.js";

const copyText = (text: string): Promise<CopyOutcome> =>
    navigator.clipboard.writeText(text).then(
        (): CopyOutcome => "copied",
        (): CopyOutcome => "refused",
    );

export const clipboardHttp: ClipboardPorts = { copyText };
